import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=2335bfc9&scoped=true"
import script from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=2335bfc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335bfc9",
  null
  
)

export default component.exports